import React , { Component } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import Toggle from '../common/Toggle';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import Loading from '../common/Loading';

import FilterConversation from '../DropdownMenu/FilterReminder';
import FileDownload from '../Dashboard/images/file_download.png';
import Appointmentrate from '../../assets/images/appointment.svg';
import Noshowup from '../../assets/images/np-showups.svg';
import Timesaved from '../../assets/images/time-saved.svg';
import filterIcon from '../../assets/images/filter_icon.svg';
import filter_icon from '../../assets/images/filter_icon.svg';
import filter_icon_blue from '../../assets/images/filter_icon_blue.svg';
import chevronLeft from '../../assets/images/chevron-left.svg';
import moveToConv from '../../assets/images/move-to-conv.svg';
import infoCursor from '../../assets/images/info_cursor.svg';
import banner from '../../assets/images/appt_reminder_banner.svg';
import 'react-circular-progressbar/dist/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import './index.scss';
import utils from '../../lib/utils';

const CustomDatePickerInput = ({ value, onClick, formatDate }) => (
  <input
    type="text"
    className='day-of-month custom-date-picker'
    value={value ? formatDate(value) : ''}
    onClick={onClick}
    readOnly
  />
);

const CustomHeader = ({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled , selectedToday}) => (
  <div>
    <button onClick={selectedToday}>Today</button>
    <div>
      {moment(date).format('ddd, MMM D')}
    </div>
    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>{'<'}</button>
    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>{'>'}</button>
  </div>
);

const formatDate = date => moment(date).format('ddd, MMM D');

const formatPhoneNumber = (phoneNumberString) => {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  } else {
    return phoneNumberString;
  }
};

const status_map = {
   'CONFIRMED' : 'Confirmed', 
  'RESCHEDULED' : 'Rescheduled', 
  'CANCELLED' : 'Canceled',
  'IN_PROGRESS' : 'In progress', 
  'OPTED_OUT' : 'Opted out', 
  'UNCONFIRMED' : 'Unconfirmed', 
  'CONFIRMED_OFF_PLATFORM': 'Confirmed off Platform',
  'UNABLE_TO_SEND': 'Reminders unavailable',
  'RESCHEDULE_REQUESTED':'Reschedule requested',
  'CANCEL_REQUESTED': 'Cancel requested',
  'CONFIRMED_VIA_VOICE': 'Confirmed via voice',
};

const color_map = {
  'CONFIRMED' : '#5F9619', 
  'CONFIRMED_OFF_PLATFORM': '#5F9619',
  'CONFIRMED_VIA_VOICE': '#5F9619',
  'RESCHEDULED': '#C7B453', 
  'RESCHEDULE_REQUESTED':'#C7B453',
  'CANCELLED': '#9B4B01',
  'CANCEL_REQUESTED':'#9B4B01',
 'IN_PROGRESS' : '#45ABEA', 
 'OPTED_OUT' : '#5F72AD', 
 'UNCONFIRMED' : '#5F6A79', 
 'UNABLE_TO_SEND' : '#959FAC'
};
export default class AppointmentReminder extends Component{
    constructor(props) {
        super(props);
        this.startRef = React.createRef();
        this.buttonRef = React.createRef();
        this.state = {
          toggle:false,
          showFilter:false,
          selectedDate: new Date(),
          filter:[],
          appliedfilter:[]
          }
        };
      
    componentDidMount(){
      const { selectedDate } = this.state;
      this.props.getConversationReminders(
        {
          "start_time" : moment(selectedDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss') ,
          "end_time" : moment(selectedDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss')
        }      
      );
      if (this.props.business && this.props.business.id) {
        const { auth } = this.props;
        const { studio_id } = auth;
        const bzid = this.props.business.id || studio_id;
        this.props.getReminderStats(bzid);
      }
      const features = utils.getCookie('features');
      if(features.includes("APPOINTMENT_REMINDER_LIVE")){
        this.setState({
          toggle:true
        })
      }
    }
    componentWillReceiveProps(nextProps){
      if (
        nextProps.business.isInfoFetched &&
        nextProps.business.isInfoFetched !== this.props.business.isInfoFetched
      ) {
        const { auth } = this.props;
        const { studio_id } = auth;
        const bzid = nextProps.business.id || studio_id;
        this.props.getReminderStats(bzid);
      }
    }
    createDisabled = ()=>{
      return false;
    }
    onSetupClick=()=>{
      if (ReactTooltip && ReactTooltip.show) {
        // Hide the tooltip
        ReactTooltip.hide(this.buttonRef.current);
        utils.setCookie('reminderSetupMessageShown',true);
      }
      this.props.history.push('/app/remindersetup');
    }
    onConversationClick=(user_id)=>{
      console.log('user_id',user_id);
      //this.props.history.push(`/app/conversation?userId=${user_id}`);
      window.open(window.Config.API_URL+`/#/app/conversation?userId=${user_id}`, "_blank")
    }
    
    ToggleButton=(event)=>{
      console.log('ToggleButton', this.state.toggle , event.target.value);
      this.setState({
        toggle:!this.state.toggle
      },()=>this.props.updateReminderStatus((this.state.toggle)?'ENABLED':'DISABLED'));
    }
    goForward=()=>{
      const addedDate = new Date(moment(this.state.selectedDate).add(1,'days'));
      if(!moment(this.state.selectedDate).isAfter(moment().add(14,'days')) ){
      this.setState({
        selectedDate: addedDate
      })
      this.getConversationList(addedDate);
      }
    }


    goBackward=()=>{
      const substratedDate = new Date(moment(this.state.selectedDate).subtract(1,'days'));
      if(!moment(this.state.selectedDate).isBefore(moment().subtract(14,'days'))){
      this.setState({
        selectedDate: substratedDate
      })
      this.getConversationList(substratedDate);
      }
    }

    getConversationList=(date)=>{
      this.props.getConversationReminders(
        {
          "start_time" : moment(date).startOf('day').format('YYYY-MM-DDTHH:mm:ss') ,
          "end_time" : moment(date).endOf('day').format('YYYY-MM-DDTHH:mm:ss')
        }      
      );
    }

    onSelectDate=(date,selectedDate)=>{
      console.log('selectedDate',selectedDate,date);
      this.setState({
        [selectedDate]:new Date(date)
      })
      this.getConversationList(date);
    }

    selectedToday=()=>{
      this.setState({
        selectedDate: new Date()
      })
      this.getConversationList(new Date());
      if (this.startRef.current) {
        this.startRef.current.setOpen(false); // Close the date picker
        this.startRef.current.input.blur(); // Blur the input to remove focus
      }
    }
    showFilterDropdown=(visibility)=>{
      const { appliedfilter } = this.state;
      this.setState({
        showFilter: visibility,
        filter: appliedfilter,
      });
    };
    onFilterChange = (event) => {
      const { filter } = this.state;
      let temp = [...filter];
      if (temp.includes(event)) {
        temp = temp.filter((element) => element != event);
      } else {
        temp.push(event);
      }
      this.setState({
        filter: temp,
      });
    };

    applyFilter=()=>{
      const { filter } = this.state;
      console.log('showFilter',filter);
        this.setState(
          {
            appliedfilter: filter,
            showFilter: false
          });
    }
      clearFilter=()=>{
        this.setState({
          filter: [],
          appliedfilter:[]
        })
      }
      getValueList=(dataArray,key)=>{
        let values = '';
        for(let i=0;i<dataArray.length;i++){
          values+=dataArray[i].name+' ';
          values+= i<dataArray.length-1 ?',\xa0':'';
        }
        return values;
      }
      filterBasedOnStatus=(conversations)=>{
        const { appliedfilter } = this.state;
        return appliedfilter.length>0? conversations.filter(conversation=>appliedfilter.includes(conversation.workflow_status)).sort((a,b)=>new Date(a.start_time).getTime().toString()-new Date(b.start_time).getTime().toString()): conversations.sort((a,b)=>new Date(a.start_time).getTime().toString()-new Date(b.start_time).getTime().toString());
      }
      downloadReport=()=>{
        const {  business } = this.props;
        let filename = `TrueLark-${
          business.info.BUSINESS_NAME
        }-Reminders_reports-${moment().format('YYYY-MM-DD:HH:mm:ss')}.xlsx`;
        this.props.downloadReminder(filename);
      }

      render() {
        const { toggle ,selectedDate ,showFilter, filter, appliedfilter} = this.state;
        const { auth , appointmentreminder } = this.props;
        const { loading, conversation , statsLoading, stats} = appointmentreminder;
        const { features } = auth;
        const confirmation_rate = (stats?.appointments_confirmed * 100)/stats?.reminders_sent || 0;
        const isFeatureEnabled = features.includes("APPOINTMENT_REMINDER_ENABLED");
        const showSetupMessage = utils.getCookie('reminderSetupMessageShown');
        const filteredList = this.filterBasedOnStatus(conversation);
        return (<div className="booking-reminder">
        
            <div className='booking-reminder_title'>
              <div className="booking-reminder_title_content">
                <div className='title-with-toggle'>
                  <div className="title">Appointment Reminders</div>
                  {isFeatureEnabled && <><Toggle onClick={this.ToggleButton} data={toggle}/>
                  <div className='toggle-status'>{toggle?'ENABLED':'DISABLED'}</div>
                  </>}
                </div>
                {isFeatureEnabled ?
                (<button ref={this.buttonRef} data-class="multiline-tooltip" data-multiline={true} data-place={'left'} html={true} data-tip={'Setup reminder schedule to start sending <br/> reminders for all your appointments and <br/> track TrueLark performance'} className="add_reminder" data-tooltip-hidden={!this.createDisabled()|| !showSetupMessage} style={{ opacity: (this.createDisabled() ? 0.5 : 1) }}  onClick={this.onSetupClick} disabled={this.createDisabled()}>Reminder Setup</button>
                ):(
                  <div className='upgrade-text'> Upgrade to get access to this feature. </div>
                )
              }
              </div>
            </div>
          {isFeatureEnabled ? (<> 
            { statsLoading ?
          (<div className="add-campaign_loader">
            <Loading />
          </div>):(<>
            
            <div className='booking-reminder_reports'>
            <div className='booking-reminder_reports_content'>
                <div className='booking-reminder_reports_content_download'>
                  <div className='title'>
                    <div className='main'>Performance</div>
                    <div className='sub'>In the last 30 days</div>
                  </div>
                  <div className='download-btn' onClick={this.downloadReport}>
                    <img src= {FileDownload} />
                    <span>Download report</span>
                  </div>
                </div>
                <div className='booking-reminder_reports_content_metrics'>
                <ReactTooltip />
                  <div className='report-card confirmation-rate'>
                      <CircularProgressbar value={confirmation_rate} strokeWidth={16} styles={{height: '74px' , width: '74px' }} />
                      <div className='data'>
                          <div className='value'>{Math.round(confirmation_rate)}%</div>
                          <div className='description'>Confirmation Rate</div>
                      </div>
                      <img className='cursor-hover' src={infoCursor}  data-class="multiline-tooltip" data-multiline={true} data-place={'top'} html={true} data-tip={'The percentage of successfully <br /> confirmed appointments'} />
                  </div>
                  <div className='report-card appointments'>
                    <img className='report-card_icon' src= {Appointmentrate} />
                    <div className='data'>
                          <div className='value'>{stats?.reminders_sent}</div>
                          <div className='description'>Appointments</div>
                    </div>
                    <img className='cursor-hover' src={infoCursor} data-class="multiline-tooltip" data-multiline={true} data-place={'top'} html={true} data-tip={'Total appointment <br /> reminders sent this month'} />
                  </div>
                  <div className='report-card no-shows-avoided'>
                    <img className='report-card_icon' src= {Noshowup} />  
                    <div className='data'>
                          <div className='value'>{stats?.appointments_rescheduled+ stats?.appointments_canceled}</div>
                          <div className='description'>No-Shows Avoided</div>
                      </div>
                      <img className='cursor-hover' src={infoCursor} data-class="multiline-tooltip" data-multiline={true} data-place={'top'} html={true} data-tip={'Appointments rescheduled <br /> or cancelled'} />
                  </div>
                  <div className='report-card time-saved'>
                    <img className='report-card_icon' src= {Timesaved} />
                    <div className='data'>
                          <div className='value'>{Math.round(moment.duration(stats?.time_saved).asHours())+'h'}</div>
                          <div className='description'>Time Saved</div>
                      </div>
                      <img className='cursor-hover' src={infoCursor} data-class="multiline-tooltip" data-multiline={true} data-place={'top'} html={true} data-tip={'5 min for every <br /> reminder sent'} />
                  </div>
                </div>
            </div>
            </div>
            

            <div className='booking-reminder_conv-list'>
                  <div className='booking-reminder_conv-list_content'>
                    <div className='calendar-filter'>
                      <div className='calendar-filter_date'> 
                       <img src={chevronLeft} className={classnames('chevron',{ 'disabled-input': moment(selectedDate).isBefore(moment().subtract(14,'days')) })} disabled={moment(selectedDate).isBefore(moment().subtract(14,'days'))} onClick={this.goBackward}/> 
                       <img src={chevronLeft} className={classnames('chevron',{ 'disabled-input': moment(selectedDate).isAfter(moment().add(14,'days')) })} disabled={moment(selectedDate).isAfter(moment().add(14,'days'))}  onClick={this.goForward} style={{ rotate: '180deg'}}/>
                       <span className='day-of-month' onClick={(e) =>this.datePickerVisible(e, this.startRef)}></span>
                      { moment(moment().startOf('day')).diff(moment(selectedDate).startOf('day'), 'days') === 0 && <span className='today'>Today,</span> }
                       <DatePicker
                                  ref={this.startRef}
                                  selected={selectedDate}
                                  onChange={(date) =>
                                    this.onSelectDate(date, 'selectedDate')
                                  }
                                  useWeekdaysShort={true}
                                  customInput={<CustomDatePickerInput formatDate={formatDate} />}
                                  customHeader={<CustomHeader selectedToday={this.selectedToday}/>}
                                  placeholderText="Select Date"
                                  minDate={new Date(moment().subtract(15,'days'))}
                                  maxDate={new Date(moment().add(15,'days'))}
                                 
                                 // className={classnames({ 'disabled-input' })}
                        >
                          <div className='custom-calendar'>
                          <button
                          className='custom-button-today'
                            onClick={() => {
                              this.selectedToday()
                            }}
                          >
                            Today
                          </button>
                        </div>
                        </DatePicker>
                      </div>
                      <div className='calendar-filter_filter'> 
                          <a
                          href="#"
                          onClick={(event) => {
                            event.stopPropagation();
                            event.preventDefault();
                            this.showFilterDropdown(!showFilter);
                          }}
                          >
                             <div className='filter-container'>
                            {appliedfilter.length>0?(<img src={filter_icon_blue}/> ): (<img src={filter_icon}/>)}  <span>Filter by status</span>
                            {appliedfilter.length>0 &&
                            <div className="filter-count-container"><div className="filter-count">{appliedfilter.length}</div></div>
                            }
                            </div>
                          </a>                     
                            <FilterConversation
                              visibility={showFilter}
                              position="brc"
                              onVisibilityChange={(visibility) => {
                                this.showFilterDropdown(visibility);
                              }}
                              className="menu__dropdown conversation-filter"
                              onChange={(event) => {
                                this.onFilterChange(event);
                              }}
                              filter={filter}
                              clearFilter={this.clearFilter}
                              applyFilter={this.applyFilter}
                            />
                      </div>
                    </div>
                    <div className='column-titles'>
                      <div className='title time'>TIME</div>
                      <div className='title service-type'>SERVICE TYPE</div>
                      <div className='title client'>CLIENT</div>
                      <div className='title status'>REMINDER STATUS</div>
                      <div className='title empty'></div>
                    </div>
              <div className='list-container'>
                    {loading && <div className="loader"></div>}
                    {conversation.length<1?
                    (<div className='empty-list'>
                    <div className='column-data_empty-list'>No data available for the selected date.</div>
                    </div>):(<>
                    {filteredList.length < 1 ? (<div className='empty-list'><div className='column-data_empty-list'>No results for selected filters.</div></div>):(<>
                    {this.filterBasedOnStatus(conversation).map(conv=>
                      <div className='column-data'>
                        <div className='time'>
                          <div className='schedule-time'>{moment(conv.start_time,'YYYY-MM-DDTHH:mm:ss').format('hh:mm A')}</div>
                        </div>
                        <div className='service-type'>
                          {this.getValueList(conv.services,'name')|| 'Unknown Service'}
                        </div>
                        <div className='client'>
                          <div className='name-phone'><span className='name-phone_name'>{conv.client_name}</span> <span className='name-phone_phone'>{formatPhoneNumber(conv.client_phone)}</span> </div>
                          <div className='email'>{conv.client_email}</div>
                        </div>
                        <div className='status'>
                          <div className='status-name' style={{color:color_map[conv.workflow_status]}}>{status_map[conv.workflow_status]}</div>
                          {/* <div className='count'>by TrueLark</div> */}
                        </div>
                        <div className='empty'>
                        {(conv.workflow_status==='UNABLE_TO_SEND' || conv.workflow_status==='CONFIRMED_OFF_PLATFORM')?
                        <></>:
                        (
                            <div className='img-container'>
                              <img src={moveToConv}  data-class="multiline-tooltip" data-multiline={true} data-place={'top'} html={true} data-tip={'Open conversation'} onClick={()=>this.onConversationClick(conv.user_id)}/>
                            </div>
                          )}
                        </div>
                      </div>
                      
                      )}
                      </>)}
                      </>)}
                </div>
              </div>
            </div>
            </>)}
          </>):(
            <div className='booking-reminder_feature-disabled'>
              <div className='booking-reminder_feature-disabled_content'>
                  <div className='feature-info'>
                    <div className='feature-info_title'>Get started with Appointment Reminders</div>
                    <div className='feature-info_body'>
                    Upgrade to enable appointment reminders for efficient scheduling, reduced no-shows, and easy rescheduling. <br/><br/>
                    {features && !features.includes('CONTACT_INFO_HIDDEN') && 
                      <>
                        Reach us at  <a href="mailto:support@truelark.com">support@truelark.com</a>  or call <span>+1-408-582-7010</span>
                      </>
                    }
                    </div>
                  </div>
                  <div className='feature-banner'>
                    <div><img src={banner} /></div>
                  </div>
              </div>
            </div>
          )}        
        </div>)
        }
        
}